"use client";

import { twMerge } from "tailwind-merge";

import { NormalText } from "@/components/text/NormalText";
import { allPitchRangeCategories } from "@/constants/selectArtistFilters";
import { useNamedSelectArtistFilters } from "@/lib/zustand/useSelectArtistFilters";
import { classNames } from "@/utils/classNames";

export function PitchRangeCategoryFilterPart({
  className,
  namespace,
}: {
  namespace: string;
  className?: string;
}) {
  const useSelectArtistFilters = useNamedSelectArtistFilters((state) =>
    state.getNamedStore(namespace)
  );
  const pitchRangeCategoryFilterShow = useSelectArtistFilters(
    (state) => state.pitchRangeCategoryFilterShow
  );
  const togglePitchRangeCategoryFilterShow = useSelectArtistFilters(
    (state) => state.togglePitchRangeCategoryFilterShow
  );

  const allPitchRangeCategoriesSelected = allPitchRangeCategories.every(
    (category) => pitchRangeCategoryFilterShow.has(category)
  );

  const lastIndex = allPitchRangeCategories.length - 1;

  return (
    <div className={twMerge("", className)}>
      <NormalText elementType="p" className="mb-1 text-gray-400">
        PITCH RANGE
      </NormalText>
      <div className={"grid w-fit grid-cols-5"}>
        {allPitchRangeCategories.map((filter, index) => (
          <button
            data-tutorial={`pitch-range-${filter.replaceAll(" ", "-").toLowerCase()}`}
            key={filter}
            className={classNames(
              (
                pitchRangeCategoryFilterShow.has(filter) &&
                  !allPitchRangeCategoriesSelected
              ) ?
                "border-primary bg-primaryLight"
              : "border-gray-400 bg-white",
              index === 0 ? "rounded-l-3xl" : "",
              index !== 0 && index === lastIndex ? "rounded-r-3xl" : "",
              "border px-2 py-1 transition-colors"
            )}
            onClick={() => togglePitchRangeCategoryFilterShow(filter)}
          >
            <NormalText
              elementType="span"
              className={classNames(
                (
                  pitchRangeCategoryFilterShow.has(filter) &&
                    !allPitchRangeCategoriesSelected
                ) ?
                  "text-gray-900"
                : "text-gray-900",
                "whitespace-nowrap transition-colors"
              )}
            >
              {filter}
            </NormalText>
          </button>
        ))}
      </div>
    </div>
  );
}
